import {onError} from 'apollo-link-error'
import {configureRollbar} from '../../../utils'
import rollbar from '@cred/shared/rollbar'

function getErrorLink(cookies) {
  return onError(context => {
    const {graphQLErrors, networkError} = context

    if (graphQLErrors) {
      const email = cookies ? cookies.get('email') : null

      if (email) {
        configureRollbar(decodeURIComponent(email))
      }

      graphQLErrors.map(({message, locations, path}) => {
        // Log Graphql Errors
        const msg = `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`

        rollbar.error(msg, {cookies: cookies ? cookies.cookies : {}})
        console.error(msg)
      })
    }

    if (networkError) {
      let query = '[unknown]'

      try {
        query = context.operation.query.definitions.map(definition => {
          const op = definition.operation,
            name = definition.selectionSet.selections.map(selection => {
              return selection.name.value
            })

          return `[${op}: ${name}]`
        })
      } catch (e) {
        console.error('Error parsing Graphql Network Error', e)
      }

      console.error(`[Network error]: ${networkError} ${query}`)
      rollbar.error(`[Network error]: ${networkError} ${query}`)
    }
  })
}

export default getErrorLink
